var map = {
	"./breadcumbs/locales/en-US.json": 98998,
	"./breadcumbs/locales/es-ES.json": 33349,
	"./breadcumbs/locales/pt-BR.json": 38151,
	"./breadcumbs/locales/pt-PT.json": 11301,
	"./cashiersSidesheet/locales/en-US.json": 82317,
	"./cashiersSidesheet/locales/es-ES.json": 48377,
	"./cashiersSidesheet/locales/pt-BR.json": 11015,
	"./cashiersSidesheet/locales/pt-PT.json": 95649,
	"./exportTypeSidesheet/locales/en-US.json": 12754,
	"./exportTypeSidesheet/locales/es-ES.json": 47500,
	"./exportTypeSidesheet/locales/pt-BR.json": 42022,
	"./exportTypeSidesheet/locales/pt-PT.json": 65414,
	"./global/locales/en-US.json": 95427,
	"./global/locales/es-ES.json": 13653,
	"./global/locales/pt-BR.json": 60887,
	"./global/locales/pt-PT.json": 63605,
	"./layout/presentation/locales/en-US.json": 66939,
	"./layout/presentation/locales/es-ES.json": 61613,
	"./layout/presentation/locales/pt-BR.json": 61339,
	"./layout/presentation/locales/pt-PT.json": 18493,
	"./saasPlansOverlay/locales/en-US.json": 8172,
	"./saasPlansOverlay/locales/es-ES.json": 5035,
	"./saasPlansOverlay/locales/pt-BR.json": 7775,
	"./saasPlansOverlay/locales/pt-PT.json": 59938,
	"./selectPaymentMethod/locales/en-US.json": 5436,
	"./selectPaymentMethod/locales/es-ES.json": 74412,
	"./selectPaymentMethod/locales/pt-BR.json": 17466,
	"./selectPaymentMethod/locales/pt-PT.json": 84617,
	"./sidesheet/locales/pt-BR.json": 94754,
	"./ui/locales/en-US.json": 73468,
	"./ui/locales/es-ES.json": 52012,
	"./ui/locales/pt-BR.json": 50023,
	"./ui/locales/pt-PT.json": 97378,
	"components/breadcumbs/locales/en-US.json": 98998,
	"components/breadcumbs/locales/es-ES.json": 33349,
	"components/breadcumbs/locales/pt-BR.json": 38151,
	"components/breadcumbs/locales/pt-PT.json": 11301,
	"components/cashiersSidesheet/locales/en-US.json": 82317,
	"components/cashiersSidesheet/locales/es-ES.json": 48377,
	"components/cashiersSidesheet/locales/pt-BR.json": 11015,
	"components/cashiersSidesheet/locales/pt-PT.json": 95649,
	"components/exportTypeSidesheet/locales/en-US.json": 12754,
	"components/exportTypeSidesheet/locales/es-ES.json": 47500,
	"components/exportTypeSidesheet/locales/pt-BR.json": 42022,
	"components/exportTypeSidesheet/locales/pt-PT.json": 65414,
	"components/global/locales/en-US.json": 95427,
	"components/global/locales/es-ES.json": 13653,
	"components/global/locales/pt-BR.json": 60887,
	"components/global/locales/pt-PT.json": 63605,
	"components/layout/presentation/locales/en-US.json": 66939,
	"components/layout/presentation/locales/es-ES.json": 61613,
	"components/layout/presentation/locales/pt-BR.json": 61339,
	"components/layout/presentation/locales/pt-PT.json": 18493,
	"components/saasPlansOverlay/locales/en-US.json": 8172,
	"components/saasPlansOverlay/locales/es-ES.json": 5035,
	"components/saasPlansOverlay/locales/pt-BR.json": 7775,
	"components/saasPlansOverlay/locales/pt-PT.json": 59938,
	"components/selectPaymentMethod/locales/en-US.json": 5436,
	"components/selectPaymentMethod/locales/es-ES.json": 74412,
	"components/selectPaymentMethod/locales/pt-BR.json": 17466,
	"components/selectPaymentMethod/locales/pt-PT.json": 84617,
	"components/sidesheet/locales/pt-BR.json": 94754,
	"components/ui/locales/en-US.json": 73468,
	"components/ui/locales/es-ES.json": 52012,
	"components/ui/locales/pt-BR.json": 50023,
	"components/ui/locales/pt-PT.json": 97378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71487;